'use strict';

require('./build/buildDateRangeUnitsCall');

// This package does not export anything as it is
// simply defining "minutes" on Range.prototype.


//////////////////
// WEBPACK FOOTER
// ./~/sugar-date/range/minutes.js
// module id = 407
// module chunks = 0